import { useTranslation } from "react-i18next";

import { NavItemType } from "@/components/Navbar/Navbar";

import { getLocalizedPath, isSupportedLang } from "../config/routes";

const useNavItems = () => {
  const { t, i18n } = useTranslation();
  const resolved = i18n.resolvedLanguage ?? "fr";
  const lang = isSupportedLang(resolved) ? resolved : "fr";

  const navItems: NavItemType[] = [
    { href: `/${lang}/#services`, text: t("nav.services") },
    { href: `/${lang}/#about`, text: t("nav.studio") },
    { href: `/${lang}/#portfolio`, text: t("nav.projects") },
    { href: getLocalizedPath("vitrines", lang), text: t("nav.showcases") },
    { href: getLocalizedPath("whyWebsite", lang), text: t("nav.whyWebsite") },
    { href: getLocalizedPath("audit", lang), text: t("nav.audit") },
    { href: getLocalizedPath("blog", lang), text: t("nav.blog") },
    { href: `/${lang}/#contact`, text: t("nav.contact"), hilight: true },
  ];

  return navItems;
};

export default useNavItems;
